import $ from 'jquery';
import 'jquery-ui/ui/widgets/autocomplete.js';
import * as ecommercetracking from '../ecommercetracking.js';
import { StripFirstTwoOrgNo } from './utils.js';

$(document).ready(function () { 

    // Setup autocomplete for Company search
    setupAutocomplete('input[name="searchString"]', function(ui) {
        var $form = $(this).closest('form');
        ecommerceAddToCart(ui, $form);
        $form.find(".search-company-form");
        $form.find(".search-company-form").fadeOut(250);
        $form.find('input[name="OrderCompanyId"]').val(StripFirstTwoOrgNo(ui.item.orgNo));
        $form.find('input[name="OrderCompanyName"]').val(ui.item.value);
        $form.find('input[name="searchString"]').val(ui.item.orgNo);
        $form.submit();
        $(this).val("");
    });

    // Setup autocomplete for ESG search
    setupAutocomplete('input[name="searchEsgString"]', function(ui) { 
        $('.esg-failed').hide();
        const addDashes = (string) => string.slice(0,6) + "-" + string.slice(6,10);
        $('.esg-company').html(ui.item.value + " (" + addDashes(StripFirstTwoOrgNo(ui.item.orgNo)) + ")");
        var url = $('.js-get-esgreport').attr('href').replace(/\/$/, '');
        $('.js-get-esgreport').attr('href', url + '?orgNo=' + ui.item.orgNo);
        $("#approve-btn").removeClass('disabled');
        $("#esgModal").modal();
    });

    // Clear input when ESG modal is closed
    $('#esgModal').on('hidden.bs.modal', function () {
        $('input[name="searchEsgString"]').val("");
        let baseUrl = $('.js-get-esgreport').attr('href');
        baseUrl = baseUrl.replace(/orgNo=[^&]*/g, "");
        baseUrl = baseUrl.replace("?", "");
        $('.js-get-esgreport').attr('href', baseUrl);
    });

    // Add product to datalayer
    function ecommerceAddToCart(ui, $form) {
        var input = $form.children("input");

        if (parseInt(filterAttribute(input, 'Price').val()) > 0) {
            var productFieldObject = {
                name: filterAttribute(input, 'SalePackageName').val(),
                id: filterAttribute(input, 'salePackageId').val(),
                price: filterAttribute(input, 'Price').val(),
                quantity: 1,
                variant: filterAttribute(input, 'Channel').val(),
                brand: ui.item.orgNo
            };
            ecommercetracking.addToCart($.makeArray(productFieldObject), ui.item.orgNo);
        }
    }

    // Transform to lowercase
    function filterAttribute(inputs, attributeName) {
        return inputs.filter(function () {
            return $(this).attr('name') && $(this).attr('name').toLowerCase() === attributeName.toLowerCase();
        });
    }

    // Setup autocomplete for company search (for Klarna)
    setupAutocomplete('#search-companyOrOrgNo', function(ui) {
        $('input[name=CompanyOrgNo]').val(ui.item.orgNo);
        $('#checkout-form').on('validated', function (e) {
            $('.new-company').addClass('faded');
            $('.orderflow__summary').hide();
            $('.orderflow__loader').fadeIn();
            $('.js-get-company-checkout-snippet').trigger('click');
        });
    }, true);

    setupAutocomplete('input[data-search-type="company-orgno"]', function (ui) {    
    }, true);

    // Function to setup autocomplete
    function setupAutocomplete(selector, selectCallback, isMinLengthOne = false) {
        $(selector).autocomplete({
            autoFocus: true,
            source: function (request, response) {
                var $input = $(this.element);
                var attributeType = $(selector).data('search-type')
                var showCompanyOrgno = attributeType === "company-orgno";
                var spinner = $('<i class="fas fa-spinner fa-spin"></i>');                
                spinner.css({
                    left: 'auto',
                    right: '15px',
                    top: showCompanyOrgno ? '16px' : '10px'
                });
                $input.after(spinner);               

                $.ajax({
                    url: $(selector).data('search-results'),
                    method: "post",
                    dataType: "json",
                    data: JSON.stringify({searchQuery: request.term.toLowerCase()}),
                    contentType: 'application/json; charset=utf-8',
                    success: function (data) {
                        spinner.remove();
                        response($.map(data, function (item) {
                            return {
                                label: item.Company.Name + " (" + StripFirstTwoOrgNo(item.OrgNumber) + ")",
                                value: showCompanyOrgno ? StripFirstTwoOrgNo(item.OrgNumber) : item.Company.Name,
                                orgNo: item.OrgNumber
                            }; 
                        }));
                    },
                    error: function() {
                        spinner.remove();
                    }
                });
            },
            select: function (event, ui) {
                selectCallback.call(this, ui);

                if (!isMinLengthOne)
                    $(this).val("");
            },
            minLength: isMinLengthOne ? 1 : 0
        });
    }


    // Update styling on autocomplete results
    var oldFn = $.ui.autocomplete.prototype._renderItem;
    $.ui.autocomplete.prototype._renderItem = function (ul, item) {
        var re = new RegExp(this.term, "ig");
        var t = item.label.replace(re, "<span style='font-weight:bold;'>" + "$&" + "</span>");
        return $("<li></li>")
            .data("item.autocomplete", item)
            .append("<a>" + t + "</a>")
            .appendTo(ul);
    };
});
